module.exports = __webpack_public_path__ + "static/media/Icebox.06c9e203.png";